import { render } from "./index.vue?vue&type=template&id=24254ad5"
import script from "./navbar.ts?vue&type=script&lang=js"
export * from "./navbar.ts?vue&type=script&lang=js"

import "./navbar.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script